import { render } from "./Downloader.vue?vue&type=template&id=3728272e&scoped=true"
import script from "./Downloader.vue?vue&type=script&lang=js"
export * from "./Downloader.vue?vue&type=script&lang=js"

import "./Downloader.vue?vue&type=style&index=0&id=3728272e&scoped=true&lang=css"

import exportComponent from "/build/webui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3728272e"]])

export default __exports__